import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthTokenService } from 'src/app/services/auth-token.service';

/** Sign-in and sign-up pages: someone already signed in goes to the app. */
export const guestOnlyGuard: CanActivateFn = () => {
  let signedIn = false;
  try {
    signedIn = !!localStorage.getItem('currentUser') && inject(AuthTokenService).hasSession;
  } catch {
    signedIn = false;
  }
  return signedIn ? inject(Router).createUrlTree(['/home']) : true;
};
